import { ClientEvent } from '@udemy/event-tracking';
import { getUserConsentCategories } from './cookie-consent';
class ConsentChangeEvent extends ClientEvent {
  constructor({
    userConsentCategories
  } = {}) {
    super('ConsentChangeEvent');
    this.userConsentCategories = void 0;
    this.userConsentCategories = getUserConsentCategories(userConsentCategories);
  }
}
export { ConsentChangeEvent };
//# sourceMappingURL=events.js.map